<ng-template #loading>
    <app-component-loading></app-component-loading>
</ng-template>

<div class="task"
     *ngIf="taskData else loading"
>
    <div class="header">
        <div>
            <mat-chip class="header_default_margin"
                      style="height: 30px; background-color: #DBEAFE;"
            >
                <lucide-icon size="18"
                             name="image"
                             [strokeWidth]="1.2"
                ></lucide-icon>
                <span style="font-size: 16px; font-weight: 400;">
                    #{{ taskData.task_alias }}
                </span>


                <lucide-icon class="header_default_margin"
                             size="10"
                             name="copy"
                             color="#2563EB"
                             [strokeWidth]="1.2"
                ></lucide-icon>
            </mat-chip>

            <button mat-fab
                    [extended]="canEdit || taskData.status_current.is_archive"
                    style="background-color: #FEDDDB; height: 30px; box-shadow: unset;"
                    [matMenuTriggerFor]="status"
                    class="header_default_margin"
            >
                {{ taskData.status_current.label }}
            </button>
            <mat-menu #status="matMenu">
                @for (outStatus of availableTaskStatuses.availableOut; track outStatus.key) {
                    <button mat-menu-item
                            (click)="editTaskStatus(outStatus.key)"
                    >
                        {{ outStatus.title }}
                    </button>
                }
                <mat-divider></mat-divider>
                @for (inStatus of availableTaskStatuses.availableIn; track inStatus.key) {
                    <button mat-menu-item
                            (click)="editTaskStatus(inStatus.key)"
                    >
                        {{ inStatus.title }}
                    </button>
                }
            </mat-menu>
        </div>
        <div class="right_header_block">
            <button mat-button
                    class="header_default_margin"
                    style="background-color: #DBEAFE;"
                    [matMenuTriggerFor]="type"
            >
                {{ taskData.task_type.name }}
            </button>
            <mat-menu #type="matMenu">
                @for (type of taskTypes; track type.key) {
                    <button mat-menu-item
                            (click)="editTaskData('task_type_id', type.key)">{{ type.title }}
                    </button>
                }
            </mat-menu>

            <button mat-button
                    class="header_default_margin"
            >
                <!--                [matMenuTriggerFor]="priority"-->
                {{ 'TASKS.TEXT.IMPORTANCE_INDEX' | translate }}: {{ taskData.importance_index }}
            </button>
            <!--            <mat-menu #priority="matMenu">-->
            <!--                <button mat-menu-item>Item 1</button>-->
            <!--                <button mat-menu-item>Item 2</button>-->
            <!--            </mat-menu>-->

            <button mat-button
                    class="header_default_margin"
                    style="background-color: #DBEAFE;"
                    [matMenuTriggerFor]="importance"
            >
                {{ 'TASKS.TEXT.IMPORTANCE.' + taskImportance[taskData.importance].title | translate }}
            </button>
            <mat-menu #importance="matMenu">
                <button mat-menu-item>{{ 'TASKS.TEXT.IMPORTANCE.' + taskImportance.NORMAL.title | translate }}</button>
                <button mat-menu-item>{{ 'TASKS.TEXT.IMPORTANCE.' + taskImportance.MIDDLE.title | translate }}</button>
                <button mat-menu-item>{{ 'TASKS.TEXT.IMPORTANCE.' + taskImportance.IMPORTANT.title | translate }}</button>
            </mat-menu>

            <div class="header_default_margin header_icons">
                <lucide-icon (click)="deleteTask()"
                             size="16"
                             name="trash-2"
                             [strokeWidth]="1.2"
                ></lucide-icon>
            </div>
        </div>
    </div>
    <mat-divider style="border-top-color: #DBEAFE;"></mat-divider>
    <div class="task_body">
        <div class="content">
            <div class="data">
                <h2>
                    @if (canEdit) {
                        <app-component-input-inline
                                (emitSave)="onEditTitle($event)"
                                [value]="taskData?.title"
                        ></app-component-input-inline>
                    } @else {
                        <span>{{ taskData?.title }}</span>
                    }
                </h2>
                <div>
                    @if (canEdit) {
                        <app-component-ckeditor (emitFinish)="onEditContent($event)"
                                                [inputData]="taskData?.content">
                        </app-component-ckeditor>
                    } @else {
                        <div [innerHtml]="taskData?.content"
                             data-content="description"
                        ></div>
                    }

                </div>
                <div style="margin-top: 40px;">
                    <strong>{{ 'TASKS.DETAIL.TEXT.SUBTASK' | translate }}</strong>
                    <mat-accordion [displayMode]="'flat'"
                                   *ngIf="childSubtasks?.length">
                        @for (subTask of childSubtasks; track subTask.task_alias; let i = $index) {
                            <mat-expansion-panel class="accordion-item"
                                                 [togglePosition]="'before'"
                                                 (opened)="openStep(i)"
                                                 (closed)="closeStep(i)"
                            >
                                <mat-expansion-panel-header
                                        [collapsedHeight]="'48px'"
                                        [expandedHeight]="'48px'"
                                >
                                    <mat-panel-title class="ellipsis_text">
                                        <mat-chip class="header_default_margin"
                                                  style="height: 30px; background-color: #DBEAFE;"
                                        >
                                            <lucide-icon size="18"
                                                         name="image"
                                                         [strokeWidth]="1.2"
                                            ></lucide-icon>
                                            <span style="font-size: 16px; font-weight: 400;">
                                            {{ subTask.task_alias }}
                                        </span>
                                        </mat-chip>
                                        <mat-chip class="header_default_margin"
                                                  style="height: 30px; background-color: #DBEAFE;"
                                        >
                                            <lucide-icon size="18"
                                                         name="image"
                                                         [strokeWidth]="1.2"
                                            ></lucide-icon>
                                            <span style="font-size: 16px; font-weight: 400;">
                                            {{ subTask.status_current.label }}
                                        </span>
                                        </mat-chip>

                                        @if (subTask.due_time) {
                                            <mat-chip class="header_default_margin"
                                                      style="height: 30px; background-color: #DBEAFE;"
                                            >
                                                <lucide-icon size="18"
                                                             name="calendar-fold"
                                                             [strokeWidth]="1.2"
                                                ></lucide-icon>
                                                <span style="font-size: 16px; font-weight: 400;">
                                            {{ subTask.due_time | date:'dd.MM.yy' }}
                                        </span>
                                            </mat-chip>
                                        }

                                        @if (step() !== i) {
                                            <span class="ellipsis_text">
                                                {{ subTask.title }}
                                            </span>
                                        }
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <div>
                                    <strong>
                                        {{ subTask.title }}
                                    </strong>
                                    <div [innerHTML]="subTask.content"></div>

                                    <div style="margin: 15px 0;">
                                        <button type="button"
                                                data-action="openSubtask"
                                                mat-raised-button
                                                (click)="router.navigate(['account/tasks/all', boardAlias, subTask.task_alias])"
                                        >
                                            {{ 'BUTTON_TEXT.MORE' | translate }}
                                        </button>
                                        <button type="button"
                                                data-action="removeSubtask"
                                                mat-raised-button
                                                (click)="deleteTaskFormSubtasks(subTask.task_alias)"
                                        >
                                            <lucide-icon size="16"
                                                         name="trash-2"
                                                         [strokeWidth]="1.2"
                                            ></lucide-icon>
                                        </button>
                                    </div>
                                </div>
                            </mat-expansion-panel>
                        }
                    </mat-accordion>

                    <button type="button"
                            data-action="addSubtask"
                            mat-raised-button
                            (click)="modalService.openTemplateModal(addSubtaskView, 'xl')"
                    >
                        <lucide-icon style="margin-right: 10px;"
                                     size="16"
                                     name="circle-plus"
                                     [strokeWidth]="1.2"
                        ></lucide-icon>
                        <span>{{ 'TASKS.BUTTONS.ADD_SUBTASK' | translate }}</span>
                    </button>

                    <mat-tab-group style="margin: 40px 0;"
                                   (selectedIndexChange)="changeTab($event)"
                    >
                        <mat-tab>
                            <ng-template mat-tab-label>
                                <lucide-icon style="margin-right: 5px;"
                                             size="16"
                                             name="messages-square"
                                             [strokeWidth]="1.2"
                                ></lucide-icon>
                                {{ 'TASKS.DETAIL.TEXT.COMMENTS' | translate }}
                            </ng-template>
                            <ng-template matTabContent>
                                <app-task-detail-comments (emitLoadCommentsCount)="onLoadCommentsCount($event)"
                                                          [canCreateComments]="canCreateComments"
                                                          [commentsType]="'task'"
                                                          [key]="taskData.task_alias"
                                                          [taskData]="taskData"
                                ></app-task-detail-comments>
                            </ng-template>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                <lucide-icon style="margin-right: 5px;"
                                             size="16"
                                             name="image"
                                             [strokeWidth]="1.2"
                                ></lucide-icon>
                                {{ 'TASKS.DETAIL.TEXT.IMAGES' | translate }}
                            </ng-template>
                            <ng-template matTabContent>
                                <button (click)="onOpenModal(addImgView); isOpenAddImageModal = true"
                                        *ngIf="canEdit || observerCanEdit"
                                        class="btn btn-primary btn-sm"
                                        style="margin-top: 20px;"
                                        data-action="addImage"
                                >
                                    <lucide-icon size="20"
                                                 name="upload"
                                    ></lucide-icon>
                                    <span>
                                        {{ 'TASKS.BUTTONS.ADD_IMAGE' | translate }}
                                    </span>
                                </button>
                                <div *ngIf="!taskData.photos.length">
                                    <b>{{ 'EMPTY_LISTS.IMAGES' | translate }}</b>
                                </div>
                                <div *ngIf="taskData.photos.length"
                                     class="img-table"
                                >
                                    @for (img of taskData.photos; track img.id; let i = $index) {
                                        <div [attr.data-index-image]="i"
                                             class="img-card"
                                        >
                                        <span class="delete_image_icon"
                                              (click)="deleteImage(img)"
                                              *ngIf="canEdit || observerCanEdit"
                                        >
                                            <lucide-icon size="16"
                                                         name="x"
                                            ></lucide-icon>
                                        </span>
                                            <img (click)="selectImgUrl = img.image; onOpenModal(viewImgView, 'xl');"
                                                 [src]="img.image"
                                                 alt=""
                                                 class="preview"
                                                 data-action="openImage"><br>
                                            <small>{{ img.name }}</small>
                                        </div>
                                    }
                                </div>
                            </ng-template>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                <lucide-icon style="margin-right: 5px;"
                                             size="16"
                                             name="files"
                                             [strokeWidth]="1.2"
                                ></lucide-icon>
                                {{ 'TASKS.DETAIL.TEXT.FILES' | translate }}
                            </ng-template>
                            <ng-template matTabContent>
                                <button (click)="onOpenModal(collectionView, 'xl')"
                                        *ngIf="canEdit || observerCanEdit"
                                        class="btn btn-primary btn-sm"
                                        style="margin-top: 20px;"
                                        data-action="addCollection">
            <span>
                {{ 'TASKS.BUTTONS.ADD_COLLECTION' | translate }}
            </span>
                                </button>
                                <div *ngIf="taskData.collections.length"
                                     class="files">
                                    <div *ngFor="let item of taskData.collections; let i = index"
                                         class="file">
                                        <div [attr.data-index-collection]="i"
                                             class="collection__title">
                                            <i (click)="deleteCollection(item.id)"
                                               *ngIf="canEdit"
                                               class="icon-delete"
                                               data-action="deleteCollection"></i>
                                            <b (click)="getViewCollections(item)"
                                               data-action="openCollection">{{ item.name }}</b>
                                        </div>
                                        <div class="file__time">
                                            <small>
                                                <b>{{ helper.formatDate(item.created_at) }}</b>
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="!taskData.collections.length">
                                    <b>{{ 'EMPTY_LISTS.COLLECTIONS' | translate }}</b>
                                </div>
                                <div *ngIf="isShowCollections"
                                     style="box-shadow: -5px 3px 30px -9px rgba(34, 60, 80, 0.6);">
                                    <i (click)="isShowCollections = false"
                                       class="bi bi-x-square"
                                       data-action="closeCollection"
                                       style="margin-right: 15px; margin-top: 7px; float: right;  cursor: pointer;"></i>
                                    <h2 style="margin-left: 15px; padding-top: 5px;">{{ collectionName }}</h2>
                                    <app-component-folder-and-file-table
                                            (eventClick)="onEventClick($event)"
                                            (eventFind)="onEventFind($event)"
                                            [$mediator]="controller.$mediator"

                                            [isNeedRefreshMediator]="true"
                                            [showBackButton]="false"
                                    ></app-component-folder-and-file-table>
                                </div>
                            </ng-template>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                <lucide-icon style="margin-right: 5px;"
                                             size="16"
                                             name="history"
                                             [strokeWidth]="1.2"
                                ></lucide-icon>
                                {{ 'TASKS.DETAIL.TEXT.LOGS' | translate }}
                            </ng-template>
                            <ng-template matTabContent>
                                <app-task-detail-logs
                                        [taskAlias]="taskData.task_alias"
                                ></app-task-detail-logs>
                            </ng-template>
                        </mat-tab>
                    </mat-tab-group>
                </div>
            </div>
        </div>
        <div class="meta">
            <strong>{{ 'TASKS.DETAIL.TEXT.DEADLINES' | translate }}</strong>
            <div class="meta_data_item">
                <div class="meta_icon">
                    <lucide-icon size="16"
                                 name="calendar-fold"
                                 [strokeWidth]="1.2"
                    ></lucide-icon>
                </div>

                <div class="meta_content">
                    <small>{{ 'TASKS.DETAIL.TEXT.CREATED_AT' | translate }}</small>
                    <span> {{ taskData.created_at | date:'dd.MM.yy' }}
                        <span class="dt__time">{{ taskData.created_at | date:'HH:mm' }} </span>
                        </span>
                </div>
            </div>
            <div class="meta_data_item last">
                <div class="meta_icon">
                    <lucide-icon size="16"
                                 name="timer"
                                 [strokeWidth]="1.2"
                    ></lucide-icon>
                </div>

                <div class="meta_content">
                    <small>{{ 'TASKS.DETAIL.TEXT.DUE_TIME' | translate }}</small>
                    <span (click)="canEdit ? calendarDueTime.click() : null">
                        {{ taskData.due_time | date:'dd.MM.yy' }}
                        <span class="dt__time">
                              {{ taskData.due_time | date:'HH:mm' }}
                        </span>
                    </span>
                    <app-component-date-time-picker #calendarDueTime
                                                    (pickedDate)="editTaskData('due_time', $event)"
                                                    [hiddenCalendar]="true"
                                                    [showTime]="true"
                                                    [stringify]="false"
                                                    [timeId]="'time2'"
                    ></app-component-date-time-picker>
                </div>
            </div>

            <strong>{{ 'TASKS.DETAIL.TEXT.CREATOR' | translate }}</strong>
            <div class="meta_data_item last">
                <div class="meta_icon avatar">
                    <app-avatar *ngIf="taskData.author"
                                [profile]="taskData.author"
                                [size]="'mini'"
                    ></app-avatar>
                </div>

                <div class="meta_content"
                     *ngIf="taskData.author"
                >

                    <span (click)="profile(taskData.author, $event)"
                          class="user_profile"
                    >
                        {{ helper.shortFullName(taskData.author) }}
                    </span>
                    <small [matTooltip]="taskData.author.project_setting.position">
                        {{ taskData.author.project_setting.position ?? '-' }}
                    </small>
                </div>
            </div>

            @if (taskData.roles.responsible.length) {
                <strong>{{ 'TASKS.DETAIL.TEXT.RESPONSIBLE' | translate }}</strong>
                @for (responsible of taskData.roles.responsible; track responsible.user_guid; let i = $index) {
                    @if (responsible.memberModel) {
                        <div class="meta_data_item action last"
                             [class.last]="i === taskData.roles.responsible.length - 1"
                        >
                            <div class="meta_icon avatar">
                                <app-avatar *ngIf="responsible"
                                            [profile]="responsible.memberModel"
                                            [size]="'mini'"
                                ></app-avatar>
                            </div>

                            <div class="meta_content">
                            <span (click)="profile(responsible.memberModel, $event)"
                                  class="user_profile"
                            >
                                {{ helper.shortFullName(responsible.memberModel) }}
                            </span>
                                <small [matTooltip]="responsible.memberModel.project_setting.position">
                                    {{ responsible.memberModel.project_setting.position ?? '-' }}
                                </small>
                            </div>

                            <div class="action_icon"
                                 (click)="deleteEmployee(responsible.memberModel, 'responsible')"
                            >
                                <lucide-icon size="16"
                                             color="#2563EB"
                                             name="trash-2"
                                             [strokeWidth]="1.2"
                                ></lucide-icon>
                            </div>
                        </div>
                    }
                }
            }

            @if (taskData.roles.executor.length && showRoles) {
                <strong>{{ 'TASKS.DETAIL.TEXT.EXECUTORS' | translate }}</strong>
                @for (executor of taskData.roles.executor; track executor.user_guid; let i = $index) {
                    @if (executor.memberModel) {
                        <div class="meta_data_item action"
                             [class.last]="i === taskData.roles.executor.length - 1"
                        >
                            <div class="meta_icon avatar">
                                <app-avatar *ngIf="executor"
                                            [profile]="executor.memberModel"
                                            [size]="'mini'"
                                ></app-avatar>
                            </div>

                            <div class="meta_content">
                            <span (click)="profile(executor.memberModel, $event)"
                                  class="user_profile"
                            >
                                {{ helper.shortFullName(executor.memberModel) }}
                            </span>
                                <small [matTooltip]="executor.memberModel.project_setting.position">
                                    {{ executor.memberModel.project_setting.position ?? '-' }}
                                </small>
                            </div>

                            <div class="action_icon"
                                 (click)="deleteEmployee(executor.memberModel, 'executor')"
                            >
                                <lucide-icon size="16"
                                             color="#2563EB"
                                             name="trash-2"
                                             [strokeWidth]="1.2"
                                ></lucide-icon>
                            </div>
                        </div>
                    }
                }
            }

            @if (taskData.roles.observer.length && showRoles) {
                <strong>{{ 'TASKS.DETAIL.TEXT.OBSERVERS' | translate }}</strong>
                @for (observer of taskData.roles.observer; track observer.user_guid; let i = $index) {
                    @if (observer.memberModel) {
                        <div class="meta_data_item action"
                             [class.last]="i === taskData.roles.observer.length - 1"
                        >
                            <div class="meta_icon avatar">
                                <app-avatar *ngIf="observer"
                                            [profile]="observer.memberModel"
                                            [size]="'mini'"
                                ></app-avatar>
                            </div>

                            <div class="meta_content">
                            <span (click)="profile(observer.memberModel, $event)"
                                  class="user_profile"
                            >
                                {{ helper.shortFullName(observer.memberModel) }}
                            </span>
                                <small [matTooltip]="observer.memberModel.project_setting.position">
                                    {{ observer.memberModel.project_setting.position ?? '-' }}
                                </small>
                            </div>

                            <div class="action_icon"
                                 (click)="deleteEmployee(observer.memberModel, 'observer')"
                            >
                                <lucide-icon size="16"
                                             color="#2563EB"
                                             name="trash-2"
                                             [strokeWidth]="1.2"
                                ></lucide-icon>
                            </div>
                        </div>
                    }
                }
            }

            @if (taskData.roles.observer_contract.length && showRoles) {
                <strong>{{ 'TASKS.DETAIL.TEXT.CONTRACT_OBSERVERS' | translate }}</strong>
                @for (observerContract of taskData.roles.observer_contract; track observerContract.user_guid; let i = $index) {
                    @if (observerContract.memberModel) {
                        <div class="meta_data_item"
                             [class.last]="i === taskData.roles.observer_contract.length - 1"
                        >
                            <div class="meta_icon avatar">
                                <app-avatar *ngIf="observerContract"
                                            [profile]="observerContract.memberModel"
                                            [size]="'mini'"
                                ></app-avatar>
                            </div>

                            <div class="meta_content">
                            <span (click)="profile(observerContract.memberModel, $event)"
                                  class="user_profile"
                            >
                                {{ helper.shortFullName(observerContract.memberModel) }}
                            </span>
                                <small [matTooltip]="observerContract.memberModel.project_setting.position">
                                    {{ observerContract.memberModel.project_setting.position ?? '-' }}
                                </small>
                            </div>
                        </div>
                    }
                }
            }

            <div>
                <button (click)="onOpenModal(employeeView)"
                        type="button"
                        data-action="addMember"
                        mat-raised-button
                        style="margin-bottom: 30px;"
                >
                    <lucide-icon style="margin-right: 10px;"
                                 size="16"
                                 name="circle-plus"
                                 [strokeWidth]="1.2"
                    ></lucide-icon>
                    <span>{{ 'TASKS.BUTTONS.ADD_MEMBER' | translate }}</span>
                </button>
            </div>

            <section>
                <strong>{{ 'TASKS.DETAIL.TEXT.SELF.ADD' | translate }}</strong>
                <ul>
                    <li>
                        <mat-checkbox [(ngModel)]="addMe.executor"
                                      (change)="changeMyRole('executor', $event.checked)"
                        >
                            {{ 'TASKS.DETAIL.TEXT.SELF.EXECUTOR' | translate }}
                        </mat-checkbox>
                    </li>
                    <li>
                        <mat-checkbox [(ngModel)]="addMe.responsible"
                                      (change)="changeMyRole('responsible', $event.checked)"
                        >
                            {{ 'TASKS.DETAIL.TEXT.SELF.RESPONSIBLE' | translate }}
                        </mat-checkbox>
                    </li>
                    <li>
                        <mat-checkbox [(ngModel)]="addMe.observer"
                                      (change)="changeMyRole('observer', $event.checked)"
                        >
                            {{ 'TASKS.DETAIL.TEXT.SELF.OBSERVER' | translate }}
                        </mat-checkbox>
                    </li>
                </ul>
            </section>

            <section>
                <strong>{{ 'TASKS.DETAIL.TEXT.RECOMMENDED' | translate }}</strong>
                <div class="recommended_container">
                    @if (recommendedUsers.executor.length) {
                        <strong>{{ 'TASKS.DETAIL.TEXT.ASSIGN_EXECUTOR' | translate }}</strong>
                        @for (executor of recommendedUsers.executor; track executor.member.guid) {
                            <div class="meta_data_item action">
                                <div class="meta_icon avatar">
                                    <app-avatar *ngIf="executor"
                                                [profile]="executor.member"
                                                [size]="'mini'"
                                    ></app-avatar>
                                </div>

                                <div class="meta_content">

                                    <span (click)="profile(executor.member, $event)"
                                          class="user_profile"
                                    >
                                        {{ helper.shortFullName(executor.member) }}
                                    </span>
                                    <small [matTooltip]="executor.member.project_setting.position">
                                        {{ executor.member.project_setting.position ?? '-' }}
                                    </small>
                                </div>

                                <div class="action_icon"
                                     (click)="addEmployee(executor.member.guid, 'executor')"
                                >
                                    <lucide-icon size="16"
                                                 color="#2563EB"
                                                 name="circle-plus"
                                                 [strokeWidth]="1.2"
                                    ></lucide-icon>
                                </div>
                            </div>
                        }
                    }
                    @if (recommendedUsers.responsible.length) {
                        <strong>{{ 'TASKS.DETAIL.TEXT.ASSIGN_RESPONSIBLE' | translate }}</strong>
                        @for (responsible of recommendedUsers.responsible; track responsible.member.guid) {
                            <div class="meta_data_item action">
                                <div class="meta_icon avatar">
                                    <app-avatar *ngIf="responsible"
                                                [profile]="responsible.member"
                                                [size]="'mini'"
                                    ></app-avatar>
                                </div>

                                <div class="meta_content">

                                    <span (click)="profile(responsible.member, $event)"
                                          class="user_profile"
                                    >
                                        {{ helper.shortFullName(responsible.member) }}
                                    </span>
                                    <small [matTooltip]="responsible.member.project_setting.position">
                                        {{ responsible.member.project_setting.position ?? '-' }}
                                    </small>
                                </div>

                                <div class="action_icon"
                                     (click)="addEmployee(responsible.member.guid, 'responsible')"
                                >
                                    <lucide-icon size="16"
                                                 color="#2563EB"
                                                 name="circle-plus"
                                                 [strokeWidth]="1.2"
                                    ></lucide-icon>
                                </div>
                            </div>
                        }
                    }
                    @if (recommendedUsers.observer.length) {
                        <strong>{{ 'TASKS.DETAIL.TEXT.ASSIGN_OBSERVER' | translate }}</strong>
                        @for (observer of recommendedUsers.observer; track observer.member.guid) {
                            <div class="meta_data_item action">
                                <div class="meta_icon avatar">
                                    <app-avatar *ngIf="observer"
                                                [profile]="observer.member"
                                                [size]="'mini'"
                                    ></app-avatar>
                                </div>

                                <div class="meta_content">
                                    <span (click)="profile(observer.member, $event)"
                                          class="user_profile"
                                    >
                                        {{ helper.shortFullName(observer.member) }}
                                    </span>
                                    <small [matTooltip]="observer.member.project_setting.position">
                                        {{ observer.member.project_setting.position ?? '-' }}
                                    </small>
                                </div>

                                <div class="action_icon"
                                     (click)="addEmployee(observer.member.guid, 'observer')"
                                >
                                    <lucide-icon size="16"
                                                 color="#2563EB"
                                                 name="circle-plus"
                                                 [strokeWidth]="1.2"
                                    ></lucide-icon>
                                </div>
                            </div>
                        }
                    }
                </div>
            </section>
        </div>
    </div>

</div>

<!--
<div class="task">
    <div *ngIf="taskData else loading"
         class="task__block gbo_shadow">
        <div class="task__header row {{taskImportance[taskData.importance].color}} mobile_head">
            <div class="task__header__column task_title col-12 col-md"
                 style="margin-bottom: 10px">
                <h3 style="display: flex; flex-wrap: nowrap; margin-top: 10px">
                    <span [attr.data-task-alias]="taskData.task_alias"
                          style="width: fit-content; word-break: keep-all; margin-right: 10px; white-space: nowrap;"
                    >
                        #{{ taskData.task_alias }}
                    </span>
                    <app-component-input-inline
                            (emitSave)="onEditTitle($event)"
                            *ngIf="canEdit"
                            [value]="taskData.title"
                    ></app-component-input-inline>
                    <span *ngIf="!canEdit"
                          [attr.data-task-name]="taskData.title">{{ taskData.title }}</span>
                </h3>
            </div>
            <div class="task__header__column col-auto order-md-2 order-3 text-left">
                <app-select
                        (selectEmit)="editTaskData('importance_index', $event)"
                        [icon]="'bi bi-graph-up-arrow'"
                        [range]="importanceRange"

                        [selected]="taskData.importance_index"
                ></app-select>
            </div>
            <div class="task__header__column col-auto order-md-2 order-3 text-left">
                <app-component-button-more
                        (answer)="editTaskData('task_type_id', $event)"
                        *ngIf="canEdit else typeTemp"
                        [bold]="true"
                        [hidden]="true"
                        [variables]="taskTypes"
                        position="left">
                    <ng-container *ngTemplateOutlet="typeTemp"></ng-container>
                </app-component-button-more>
            </div>
            <div [style]="'background-color:' + taskData.status_current.data.backgrCol"
                 class="task__header__column col-auto order-md-2 order-3 text-left">
                <app-component-button-more
                        (answer)="editTaskStatus($event)"
                        *ngIf="taskData.status_current.is_finish ?
                                currentUser?.project_setting?.is_project_admin : canEdit; else statusTemp"
                        [bold]="true"
                        [hidden]="true"
                        [isTaskStatus]="true"
                        [variables]="availableTaskStatuses"
                        position="left">
                    <ng-container *ngTemplateOutlet="statusTemp"></ng-container>
                </app-component-button-more>
            </div>
            <div class="task__header__column col-auto order-md-2 order-3 text-left">
                <app-component-button-more
                        (answer)="editTaskData('importance', $event)"
                        *ngIf="canEdit; else importanceTemp"
                        [bold]="true"
                        [hidden]="true"
                        [variables]="[
                        {key: 'NORMAL', icon: 'icon-up-16px', title: 'TASKS.TEXT.IMPORTANCE.NORMAL' | translate, color: '#3CD33C'},
                        {key: 'MIDDLE', icon: 'icon-up', title: 'TASKS.TEXT.IMPORTANCE.MIDDLE' | translate, color: '#d9c72b'},
                        {key: 'IMPORTANT', icon: 'icon-up-1', title: 'TASKS.TEXT.IMPORTANCE.IMPORTANT' | translate, color: '#E62E49'}
                ]"
                        position="left">
                    <ng-container *ngTemplateOutlet="importanceTemp"></ng-container>
                </app-component-button-more>
            </div>
            <div *ngIf="canEdit"
                 class="task__header__column task_delete order-2 order-md-3 col text-md-left text-right col-md-auto"
                 data-action="deleteTask">
                <i (click)="deleteTask()"
                   class="icon-delete"
                   ngbTooltip="{{ 'TASKS.BUTTONS.DELETE_TASK' | translate }}"></i>
            </div>
        </div>

        <div class="body row">
            <div [class]="taskData.custom_properties && taskData.custom_properties.length ? 'col-md-7' : 'col-md-8'"
                 class="content col-sm-12 order-md-1 order-sm-2"
            >
                <div class="task__content mb-3">
                    <app-component-ckeditor (emitFinish)="onEditContent($event)"
                                            *ngIf="canEdit"
                                            [inputData]="taskData.content">
                    </app-component-ckeditor>
                    <div *ngIf="!canEdit"
                         [innerHtml]="taskData.content"
                         data-content="description"></div>
                </div>
                <div style="margin-top: 10px">
                    <button (click)="modalService.openTemplateModal(addSubtaskView, 'xl')"
                            *ngIf="canEdit"
                            class="btn btn-success"
                            data-action="addSubtask"
                            ngbTooltip="{{ 'TASKS.BUTTONS.ADD_SUBTASK' | translate }}"
                            style="padding: 2px 10px; margin-bottom: 10px">
                        <i class="bi bi-window-plus"></i>
                    </button>
                    <div *ngIf="childSubtasks && childSubtasks.length">
                        <h2>{{ 'TASKS.DETAIL.TEXT.CHILD_TASK' | translate }}</h2>
                        <app-component-tasks-table
                                (eventSubtaskReload)="getSubtasks()"
                                [colons]="childColons"
                                [isMini]="true"
                                [isSubtasks]="true"
                                [parentTaskAlias]="taskData.task_alias"
                                [tasks]="childSubtasks"
                                data-content="daughterTasks">
                        </app-component-tasks-table>
                    </div>
                    <div *ngIf="parentSubtasks && parentSubtasks.length"
                         style="margin-top: 15px">
                        <h2>{{ 'TASKS.DETAIL.TEXT.PARENT_TASK' | translate }}</h2>
                        <app-component-tasks-table
                                (eventSubtaskReload)="getSubtasks()"
                                [colons]="parentColons"
                                [isMini]="true"
                                [isSubtasks]="true"
                                [parentTaskAlias]="taskData.task_alias"
                                [tasks]="parentSubtasks"
                                data-content="parentTasks"
                        ></app-component-tasks-table>
                    </div>
                </div>
                <div class="task__footer order-3">
                    <div class="super__tabs"
                         style="margin-top: 15px">
                        <div (click)="tab = 'comments'"
                             [class.active]="tab === 'comments'"
                             class="super__tabs tab"
                             data-action="comments">
                            <span>{{ 'TASKS.DETAIL.TEXT.COMMENTS' | translate }} ({{ taskData.comments_count }})</span>
                        </div>
                        <div (click)="tab = 'images'; getTaskImage()"
                             [class.active]="tab === 'images'"
                             class="super__tabs tab"
                             data-action="images">
                            <span>{{ 'TASKS.DETAIL.TEXT.IMAGES' | translate }} ({{ taskData.photos?.length }})</span>
                        </div>
                        <div (click)="tab = 'files'"
                             [class.active]="tab === 'files'"
                             class="super__tabs tab"
                             data-action="files">
                            <span>{{ 'TASKS.DETAIL.TEXT.FILES' | translate }} ({{ taskData.collections?.length }})</span>
                        </div>
                        <div (click)="tab = 'logs'"
                             [class.active]="tab === 'logs'"
                             class="super__tabs tab"
                             data-action="logs"
                             ngbTooltip="{{ 'TASKS.DETAIL.TEXT.LOGS' | translate }}">
                            <span><i class="bi bi-clock-history"></i></span>
                        </div>
                    </div>
                    <div class="tab__content">
                        <ng-container *ngIf="tab === 'logs'">
                            <ng-container *ngTemplateOutlet="logs"></ng-container>
                        </ng-container>
                        <ng-container *ngIf="tab === 'comments'">
                            <ng-container *ngTemplateOutlet="comments"></ng-container>
                        </ng-container>
                        <ng-container *ngIf="tab === 'files'">
                            <ng-container *ngTemplateOutlet="files"></ng-container>
                        </ng-container>
                        <ng-container *ngIf="tab === 'images'">
                            <ng-container *ngTemplateOutlet="images"></ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>

            <div *ngIf="taskData.custom_properties && taskData.custom_properties.length"
                 class="info col-sm-6 col-md-2 text-sm-left order-md-2 order-sm-1"
            >
                <div class="prop_info">
                    <app-detail-property
                            (refreshEmit)="getTaskData()"
                            [canEdit]="canEditProperties"
                            [customProperties]="taskData.custom_properties"
                            [targetKey]="taskData.task_alias"

                            [target]="'board'"
                    ></app-detail-property>
                </div>
            </div>

            <div [class]="taskData.custom_properties && taskData.custom_properties.length ? 'col-md-3' : 'col-md-4'"
                 class="info col-sm-12 col-md-3 text-sm-left text-md-center order-md-2 order-sm-1"
            >
                <div class="task__info">
                    <div data-content="taskInfo"
                         style="display: inline-block; text-align: left">
                        <p *ngIf="taskData.author">
                            {{ 'TASKS.DETAIL.TEXT.CREATOR' | translate }}:
                            <span (click)="profile(taskData.author.guid)"
                                  [class.blocked_user]="taskData.author.project_setting.observation_type === 'blocked'"
                                  [class.inactive_user]="!taskData.author.is_active"
                                  class="user_profile"
                                  data-action="openCreatorProfile"
                            >
                                <img *ngIf="taskData.author.project_setting.is_project_admin"
                                     alt="#"
                                     ngbTooltip="{{ 'USER_PROFILE.ROLE.ADMIN' | translate }}"
                                     src="../../../assets/images/admin.svg">
                                {{ helper.shortFullName(taskData.author) }}
                            </span>
                        </p>
                        <p>
                            {{ 'TASKS.DETAIL.TEXT.CREATED_AT' | translate }}:
                            <span>{{ helper.convertDateToTime(taskData.created_at) }}</span>
                        </p>
                        <p class="position-relative">
                            {{ 'TASKS.DETAIL.TEXT.DEADLINE' | translate }}:
                            <span (click)="canEdit ? calendar.click() : null"
                                  [class.editable__input]="canEdit"
                                  data-action="editDeadline">
                                <ng-container *ngIf="taskData.deadline_at">
                                    {{ taskData.deadline_at | date:'dd.MM.yyyy' }}
                                </ng-container>
                                <ng-container *ngIf="!taskData.deadline_at">
                                    {{ 'TASKS.DETAIL.TEXT.EMPTY' | translate }}
                                </ng-container>
                            </span>
                            <app-component-date-time-picker #calendar
                                                            (pickedDate)="editTaskData('deadline_at', $event)"
                                                            [hiddenCalendar]="true"
                                                            [showTime]="false"
                                                            [stringify]="true">
                            </app-component-date-time-picker>
                        </p>
                        <p class="position-relative">
                            {{ 'TASKS.DETAIL.TEXT.DUE_TIME' | translate }}:
                            <span (click)="canEdit ? calendarDueTime.click() : null"
                                  [class.editable__input]="canEdit"
                                  data-action="editDueTime">
                                <ng-container *ngIf="taskData.due_time">
                                    {{ taskData.due_time | date:'dd.MM.yyyy HH:mm' }}
                                </ng-container>
                                <ng-container *ngIf="!taskData.due_time">
                                    {{ 'TASKS.DETAIL.TEXT.EMPTY' | translate }}
                                </ng-container>
                            </span>
                            <app-component-date-time-picker #calendarDueTime
                                                            (pickedDate)="editTaskData('due_time', $event)"
                                                            [hiddenCalendar]="true"
                                                            [showTime]="true"
                                                            [stringify]="false"
                                                            [timeId]="'time2'">
                            </app-component-date-time-picker>
                        </p>
                        <div style="margin-bottom: 5px;">
                            <strong style="font-weight: bold; font-size: 14px;">
                                {{ 'TASKS.DETAIL.TEXT.DURATION' | translate }}:</strong>
                            <span [class.editable__input]="canEdit"
                                  aria-expanded="false"
                                  data-bs-toggle="dropdown">
                                    <ng-container *ngIf="taskData.duration">
                                         {{ helper.getTimeFromMinute(taskData.duration) }}
                                     </ng-container>
                                    <ng-container *ngIf="!taskData.duration">
	                                    <small>{{ 'TASKS.DETAIL.TEXT.EMPTY' | translate }}</small>
                                    </ng-container>
                                </span>
                            <ul class="dropdown-menu">
                                <li>
                                    <div class="input-group mb-3">
                                        <input #time
                                               aria-describedby="button-addon2"
                                               class="form-control"
                                               id="duration"
                                               placeholder="{{ 'TASKS.DETAIL.TEXT.ENTER_MINS' | translate }}"
                                               type="number">
                                        <button (click)="editTaskData('duration', time.value)"
                                                class="btn btn-outline-secondary"
                                                id="button-addon2"
                                                type="button">
                                            {{ 'TASKS.BUTTONS.SET' | translate }}
                                        </button>
                                    </div>
                                </li>
                                <li><a (click)="editTaskData('duration', 15)"
                                       class="dropdown-item">15 {{ 'TASKS.DETAIL.TEXT.TIME.MINS' | translate }}</a>
                                </li>
                                <li><a (click)="editTaskData('duration', 30)"
                                       class="dropdown-item">30 {{ 'TASKS.DETAIL.TEXT.TIME.MINS' | translate }}</a>
                                </li>
                                <li><a (click)="editTaskData('duration', 60)"
                                       class="dropdown-item">1 {{ 'TASKS.DETAIL.TEXT.TIME.HOUR' | translate }}</a>
                                </li>
                                <li><a (click)="editTaskData('duration', 180)"
                                       class="dropdown-item">3 {{ 'TASKS.DETAIL.TEXT.TIME.HOURS' | translate }}</a>
                                </li>
                                <li><a (click)="editTaskData('duration', 360)"
                                       class="dropdown-item">6 {{ 'TASKS.DETAIL.TEXT.TIME.HOURS' | translate }}</a>
                                </li>
                                <li><a (click)="editTaskData('duration', 720)"
                                       class="dropdown-item">12 {{ 'TASKS.DETAIL.TEXT.TIME.HOURS' | translate }}</a>
                                </li>
                                <li><a (click)="editTaskData('duration', 1440)"
                                       class="dropdown-item">1 {{ 'TASKS.DETAIL.TEXT.TIME.DAY' | translate }}</a>
                                </li>
                            </ul>
                        </div>
                        <p>
                            {{ 'TASKS.DETAIL.TEXT.EDIT' | translate }}:
                            <span>{{ taskData.updated_at | date:'HH:mm dd.MM.yyyy' }}</span>
                        </p>
                        <hr class="m-0 p-0">
                        <ng-container *ngIf="taskData.roles && showRoles">
                            <ng-container
                                    *ngTemplateOutlet="users;
                                    context: {
                                        data: {
                                            name: 'TASKS.DETAIL.TEXT.RESPONSIBLE' | translate,
                                            role: 'responsible',
                                            users: taskData.roles.responsible
                                        }
                                    }"
                            ></ng-container>
                            <ng-container
                                    *ngTemplateOutlet="users;
                                    context: {
                                        data: {
                                            name: 'TASKS.DETAIL.TEXT.EXECUTORS' | translate,
                                            role: 'executor',
                                            users: taskData.roles.executor
                                        }
                                    }"
                            ></ng-container>
                            <ng-container
                                    *ngTemplateOutlet="users;
                                    context: {
                                        data: {
                                            name: 'TASKS.DETAIL.TEXT.OBSERVERS' | translate,
                                            role: 'observer',
                                            users: taskData.roles.observer
                                        }
                                    }"
                            ></ng-container>
                            <ng-container
                                    *ngTemplateOutlet="users;
                                    context: {
                                        data: {
                                            name: 'TASKS.DETAIL.TEXT.CONTRACT_OBSERVERS' | translate,
                                            role: 'observer_contract',
                                            users: taskData.roles.observer_contract
                                        }
                                    }"
                            ></ng-container>
                        </ng-container>

                        <ng-template #users
                                     let-data="data">
                            <ng-container *ngIf="data && data['users'].length">
                                <p>
                                    {{ data.name }}:
                                </p>
                                <ul class="task__users__list">
                                    <ng-container *ngFor="let user of data['users']; let i = index">
                                        <li [attr.data-content]="data.name"
                                            [attr.data-index]="i">
                                            <i (click)="deleteEmployee(user, data['role'])"
                                               *ngIf="data.role !== 'observer_contract'"
                                               class="icon-delete"
                                               data-action="deleteUser"
                                               ngbTooltip="{{ 'TASKS.DETAIL.TEXT.DELETE_USER' | translate }}"></i>
                                            <span (click)="profile(user['guid'])"
                                                  [class.blocked_user]="user.project_setting.observation_type === 'blocked'"
                                                  [class.inactive_user]="!user.is_active"
                                                  class="user_profile"
                                                  data-action="openProfile"
                                            >
                                                <img *ngIf="user.project_setting.is_project_admin"
                                                     alt="#"
                                                     ngbTooltip="{{ 'USER_PROFILE.ROLE.ADMIN' | translate }}"
                                                     src="../../../assets/images/admin.svg">
                                                {{ helper.shortFullName(user, false) }}
                                            </span>
                                        </li>
                                    </ng-container>
                                </ul>
                            </ng-container>
                        </ng-template>

                        <p class="add__employee">
                            <button (click)="onOpenModal(employeeView)"
                                    *ngIf="boardPermissions?.is_set_other_in_task || (taskData.author_guid === currentUser?.guid)"
                                    class="btn btn-light btn-sm w-100"
                                    data-action="addMemberInTask">
                                <i class="bi bi-plus"></i>
                                {{ 'TASKS.BUTTONS.ADD_MEMBER' | translate }}
                            </button>
                        </p>

                        <div *ngIf="currentUser && (addMe.asObserver || addMe.asResponsible || addMe.asExecutor)"
                             class="list-group">
                            <strong>{{ 'TASKS.DETAIL.TEXT.SELF.ADD' | translate }}:</strong>
                            <a (click)="addEmployee(currentUser.guid, 'responsible')"
                               *ngIf="addMe.asResponsible"
                               class="list-group-item list-group-item-action"
                               data-action="addMeInTaskResponsible"
                               style="cursor: pointer; padding: 5px 10px">
                                {{ 'TASKS.DETAIL.TEXT.SELF.RESPONSIBLE' | translate }}</a>
                            <a (click)="addEmployee(currentUser.guid, 'executor')"
                               *ngIf="addMe.asExecutor"
                               class="list-group-item list-group-item-action"
                               data-action="addMeInTaskExecutor"
                               style="cursor: pointer; padding: 5px 10px">
                                {{ 'TASKS.DETAIL.TEXT.SELF.EXECUTOR' | translate }}</a>
                            <a (click)="addEmployee(currentUser.guid, 'observer')"
                               *ngIf="addMe.asObserver"
                               class="list-group-item list-group-item-action"
                               data-action="addMeInTaskObserver"
                               style="cursor: pointer; padding: 5px 10px">
                                {{ 'TASKS.DETAIL.TEXT.SELF.OBSERVER' | translate }}</a>
                        </div>

                        <div *ngIf="boardPermissions?.is_set_other_in_task || (taskData.author_guid === currentUser?.guid)"
                             style="margin-top: 15px">
                            <div *ngIf="recommendedUsers.responsible.length"
                                 class="list-group">
                                <strong>{{ 'TASKS.DETAIL.TEXT.ASSIGN_RESPONSIBLE' | translate }}:</strong>
                                <a (click)="addEmployee(user.member.guid, 'responsible')"
                                   *ngFor="let user of recommendedUsers.responsible; let i = index"
                                   [attr.data-index]="i"
                                   class="list-group-item list-group-item-action"
                                   data-action="addMemberContainer"
                                   data-role="responsible"
                                   style="cursor: pointer; padding: 5px 10px">
                                    <i class="bi bi-person-plus me-1"></i>
                                    <span [class.blocked_user]="user.member.project_setting.observation_type === 'blocked'"
                                          [class.inactive_user]="!user.member.is_active"
                                    >
                                        <img *ngIf="user.member.project_setting.is_project_admin"
                                             alt="#"
                                             ngbTooltip="{{ 'USER_PROFILE.ROLE.ADMIN' | translate }}"
                                             src="../../../assets/images/admin.svg">
                                        {{ helper.shortFullName(user.member, true) }}
                                    </span>
                                    ({{ user.number_of_mentions_in_other_tasks }})
                                </a>
                            </div>
                            <div *ngIf="recommendedUsers.executor.length"
                                 class="list-group">
                                <strong>{{ 'TASKS.DETAIL.TEXT.ASSIGN_EXECUTOR' | translate }}:</strong>
                                <a (click)="addEmployee(user.member.guid, 'executor')"
                                   *ngFor="let user of recommendedUsers.executor; let i = index"
                                   [attr.data-index]="i"
                                   class="list-group-item list-group-item-action"
                                   data-action="addMemberContainer"
                                   data-role="executor"
                                   style="cursor: pointer; padding: 5px 10px">
                                    <i class="bi bi-person-plus me-1"></i>
                                    <span [class.blocked_user]="user.member.project_setting.observation_type === 'blocked'"
                                          [class.inactive_user]="!user.member.is_active"
                                    >
                                        <img *ngIf="user.member.project_setting.is_project_admin"
                                             alt="#"
                                             ngbTooltip="{{ 'USER_PROFILE.ROLE.ADMIN' | translate }}"
                                             src="../../../assets/images/admin.svg">
                                        {{ helper.shortFullName(user.member, true) }}
                                    </span>
                                    ({{ user.number_of_mentions_in_other_tasks }})
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-template #logs>
        <app-task-detail-logs
                [taskAlias]="taskData.task_alias"
        ></app-task-detail-logs>
    </ng-template>

    <ng-template #comments>
        <app-task-detail-comments (emitLoadCommentsCount)="onLoadCommentsCount($event)"
                                  *ngIf="taskData"
                                  [canCreateComments]="canCreateComments"
                                  [commentsType]="'task'"
                                  [key]="taskData.task_alias"
                                  [taskData]="taskData"
        ></app-task-detail-comments>
    </ng-template>

    <ng-template #files>
        <button (click)="onOpenModal(collectionView, 'xl')"
                *ngIf="canEdit || observerCanEdit"
                class="btn btn-primary btn-sm"
                data-action="addCollection">
            <span>
                {{ 'TASKS.BUTTONS.ADD_COLLECTION' | translate }}
            </span>
        </button>
        <div *ngIf="taskData.collections.length"
             class="files">
            <div *ngFor="let item of taskData.collections; let i = index"
                 class="file">
                <div [attr.data-index-collection]="i"
                     class="collection__title">
                    <i (click)="deleteCollection(item.id)"
                       *ngIf="canEdit"
                       class="icon-delete"
                       data-action="deleteCollection"></i>
                    <b (click)="getViewCollections(item)"
                       data-action="openCollection">{{ item.name }}</b>
                </div>
                <div class="file__time">
                    <small>
                        <b>{{ helper.formatDate(item.created_at) }}</b>
                    </small>
                </div>
            </div>
        </div>
        <div *ngIf="!taskData.collections.length">
            <b>{{ 'EMPTY_LISTS.COLLECTIONS' | translate }}</b>
        </div>
        <div *ngIf="isShowCollections"
             style="box-shadow: -5px 3px 30px -9px rgba(34, 60, 80, 0.6);">
            <i (click)="isShowCollections = false"
               class="bi bi-x-square"
               data-action="closeCollection"
               style="margin-right: 15px; margin-top: 7px; float: right;  cursor: pointer;"></i>
            <h2 style="margin-left: 15px; padding-top: 5px;">{{ collectionName }}</h2>
            <app-component-folder-and-file-table
                    (eventClick)="onEventClick($event)"
                    (eventFind)="onEventFind($event)"
                    [$mediator]="controller.$mediator"

                    [isNeedRefreshMediator]="true"
                    [showBackButton]="false"
            ></app-component-folder-and-file-table>
        </div>
    </ng-template>

    <ng-template #images>
        <button (click)="onOpenModal(addImgView); isOpenAddImageModal = true"
                *ngIf="canEdit || observerCanEdit"
                class="btn btn-primary btn-sm"
                data-action="addImage"
        >
            <lucide-icon size="20"
                         name="upload"
            ></lucide-icon>
            <span>
                {{ 'TASKS.BUTTONS.ADD_IMAGE' | translate }}
            </span>
        </button>
        <div *ngIf="!taskData.photos.length">
            <b>{{ 'EMPTY_LISTS.IMAGES' | translate }}</b>
        </div>
        <div *ngIf="taskData.photos.length"
             class="img-table">
            <div *ngFor="let img of taskData.photos; let i = index"
                 [attr.data-index-image]="i"
                 class="img-card"
            >
                <span class="delete_image_icon"
                      (click)="deleteImage(img)"
                      *ngIf="canEdit || observerCanEdit"
                >
                    <lucide-icon size="16"
                                 name="x"
                    ></lucide-icon>
                </span>
                <img (click)="selectImgUrl = img.image; onOpenModal(viewImgView, 'xl');"
                     [src]="img.image"
                     alt=""
                     class="preview"
                     data-action="openImage">
                <br><small>{{ img.name }}</small>

            </div>
        </div>
    </ng-template>

    <ng-template #typeTemp>
        <div [class.editable__input]="canEdit">
            <div [attr.data-current-type]="taskData.task_type.name"
                 class="task_type_hide">
                <i [class]="taskData.task_type.icon"
                   style="margin-right: 5px;"></i>
                <span>{{ taskData.task_type.name }}</span>
            </div>
        </div>
    </ng-template>

    <ng-template #statusTemp>
        <div [class.editable__input]="canEdit">
            <div [attr.data-current-status]="taskData.status_current.label"
                 [style]="'cursor: default; background-color:' + taskData.status_current.data.backgrCol"
                 class="task_status {{taskData.status_current.label}}">
                <span><i [class]="taskData.status_current.data.svg.class"
                         style="margin-right: 10px"></i>{{ taskData.status_current.label }}</span>
            </div>
        </div>
    </ng-template>

    <ng-template #importanceTemp>
        <div *ngIf="taskData.importance"
             [class.editable__input]="canEdit">
            <div [attr.data-current-important]="taskData.importance"
                 class="task_priority {{taskData.importance}}">
                <i class="{{taskImportance[taskData.importance].icon}}"></i>
                <span>{{ 'TASKS.TEXT.IMPORTANCE.' + taskImportance[taskData.importance].title | translate }}</span>
            </div>
        </div>
    </ng-template>
</div>
-->
<ng-template #collectionView
             let-modal>
    <app-button-modal-close [modalSize]="'xl'"
                            [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <app-component-file-navigator
                (eventSelected)="selectCollection($event[0])"
                (eventSubmit)="addCollection(modal)"
                selectedType="collection"
        ></app-component-file-navigator>
    </div>
</ng-template>

<ng-template #employeeView
             let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h2>{{ 'MODALS.HEADERS.ADD_MEMBER' | translate }}</h2>
        <select #member
                class="form-select">
            <option hidden
                    selected
                    value="">{{ 'MODALS.FIELDS.SELECT.MEMBER' | translate }}
            </option>
            <option *ngFor="let member of allMembers"
                    value="{{member.guid}}">{{ helper.fullName(member) }}
            </option>
        </select>
        <h2>{{ 'MODALS.FIELDS.ROLE' | translate }}</h2>
        <select #role
                class="form-select">
            <option hidden
                    selected
                    value="">{{ 'MODALS.FIELDS.SELECT.ROLE.SELECT' | translate }}
            </option>
            <option value="responsible">{{ 'MODALS.FIELDS.SELECT.ROLE.RESPONSIBLE' | translate }}</option>
            <option value="executor">{{ 'MODALS.FIELDS.SELECT.ROLE.EXECUTOR' | translate }}</option>
            <option value="observer">{{ 'MODALS.FIELDS.SELECT.ROLE.OBSERVER' | translate }}</option>
        </select>
        <button (click)="addEmployee(member.value, role.value, modal)"
                [disabled]="isLockButton"
                class="btn btn-success"
                data-action="addEmployeeButton"
                style="margin-top: 13px;">
            <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.ADD' | translate }}</span>
        </button>
    </div>
</ng-template>

<ng-template #viewImgView
             let-modal>
    <app-button-modal-close (closeEmit)="imageScale = 1"
                            [modalSize]="'xl'"
                            [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <div class="image_container for_modal"
             id="imgContainer">
            <img (cdkDragMoved)="changeZoom()"
                 [src]="selectImgUrl"
                 alt=""
                 cdkDrag
                 id="zoomImg">
        </div>

        <div class="zoom_buttons">
            <button (click)="imageScale = imageScale - 1; changeZoom()"
                    [disabled]="imageScale === 1">
                <i class="bi bi-zoom-out"></i>
            </button>
            <button (click)="imageScale = 1; changeZoom()"
                    *ngIf="imageScale !== 1">
                <i class="bi bi-x-circle"></i>
            </button>
            <button (click)="imageScale = imageScale + 1; changeZoom()">
                <i class="bi bi-zoom-in"></i>
            </button>
        </div>
    </div>
</ng-template>

<ng-template #addImgView
             let-modal>
    <app-button-modal-close (closeEmit)="selectedImage = null; isOpenAddImageModal = false"
                            [modal]="modal"
    ></app-button-modal-close>
    <div class="modal-body">
        <h1>{{ 'MODALS.HEADERS.ADD_IMAGE' | translate }}</h1>
        <div class="custom-file"
             style="text-align: left;">
            <input #file
                   (change)="viewImageUpload(file.files[0], true)"
                   class="form-control"
                   id="customFile"
                   type="file">
            <label class="form-label"
                   data-browse="{{ 'MODALS.BUTTONS.SELECT' | translate }}"
                   for="customFile">{{ file.files.length ? file.files[0].name : ('MODALS.FIELDS.SELECT.EMPTY' | translate) }}</label>
        </div>
        <div>
            <label style="margin-top: 15px;">{{ 'MODALS.TEXT.ADD_IMAGE' | translate }}</label>
            <div [hidden]="!selectedImage"
                 class="img-table">
                <div class="img-card">
                <span class="delete_image_icon"
                      (click)="file.files = null; selectedImage = null"
                >
                    <lucide-icon size="16"
                                 name="x"
                    ></lucide-icon>
                </span>
                    <img alt=""
                         class="{{selectedImage ? 'display_block preview' : 'display_none'}}"
                         id="output"
                         src="#">
                    <span>{{ selectedImage?.name }}</span>
                </div>
            </div>
        </div>
        <button (click)="uploadImage(modal); isOpenAddImageModal = false"
                *ngIf="selectedImage"
                [disabled]="isLockButton"
                class="btn btn-success"
                data-action="uploadImageButton"
                style="margin-top: 35px;">
            <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.UPLOAD' | translate }}</span>
        </button>
    </div>
</ng-template>


<ng-template #addSubtaskView
             let-modal>
    <app-button-modal-close [modal]="modal"
                            modalSize="xl"></app-button-modal-close>
    <div class="modal-body">
        <h1>{{ 'MODALS.HEADERS.ADD_CHILD_TASK' | translate }}</h1>
        <app-component-tasks-table
                (emitEventSelected)="selectedSubtask = $event"
                (eventSubmit)="setSubtask(modal)"
                [isMini]="true"
                [isNavigate]="false"
                [parentTaskAlias]="taskData.task_alias"
                [subtasks]="childSubtasks.concat(parentSubtasks)"
        ></app-component-tasks-table>
    </div>
</ng-template>

<ng-template #viewDocument
             let-modal>
    <app-button-modal-close (closeEmit)="documentKey = ''"
                            [modal]="modal"
                            modalSize="xl"></app-button-modal-close>
    <div class="modal-body">
        <app-component-doc-view
                [fileUkey]="documentKey"
        ></app-component-doc-view>
    </div>
</ng-template>

<ng-template #refresh>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>
